import { useRef } from "react";
import dynamic from "next/dynamic";
import CityHeroSection from "@/components/city/sections/CityHeroSection";

// Lazy load below-the-fold components
const CityTextImageSection = dynamic(() => import("@/components/city/sections/CityTextImageSection"));
const CityToursSection = dynamic(() => import("@/components/city/sections/CityToursSection"));
const CityPhotosSection = dynamic(() => import("@/components/city/sections/CityPhotosSection"));
const CityReviewsSection = dynamic(() => import("@/components/city/sections/CityReviewsSecition"));

export default function CityPage({ data }) {
    const scrollToDivRef = useRef(null);

    const { reviewOverlay, page, socialLinks } = data?.data || {};
    const {
        heroImage,
        textAndImageImage,
        tours,
        images,
        reviews,
        reviewsLogos,
        data: pageData,
        name,
        historicalTourCardImage,
    } = page || {};
    const { hero, textAndImage, tours: toursData, images: imagesData, reviews: reviewsData, historicalCard } =
    pageData || {};

    return (
        <div>
            {/* Hero Section (Above-the-Fold) */}
            <CityHeroSection
                reviewOverlayData={reviewOverlay}
                scrollToDivRef={scrollToDivRef}
                heroMedia={heroImage}
                backgroundImageUrl={heroImage?.url}
                socialLinks={socialLinks}
                subtitle={hero?.subtitle}
                heroTitle={hero?.title}
                breadcrumbds={[
                    { title: "Home", link: "/" },
                    { title: name },
                ]}
                dropdownData={pageData?.showDropdown ? pageData?.dropdowns : []}
            />

            {/* Text and Image Section */}
                <div ref={scrollToDivRef}>
                    {(textAndImage?.title || textAndImage?.description) && textAndImageImage && (
                        <CityTextImageSection
                            reviewOverlayData={reviewOverlay}
                            title={textAndImage?.title}
                            image={textAndImageImage}
                            description={textAndImage?.description}
                            buttons={textAndImage?.buttons}
                        />
                    )}
                </div>

            {/* Tours Section */}
                <div id={'all-tours'}>
                    <CityToursSection
                        title={toursData?.title}
                        subtitle={toursData?.subtitle}
                        tours={tours}
                        historicalTour={{
                            rating: historicalCard?.rating,
                            title: historicalCard?.title,
                            description: historicalCard?.description,
                            buttonText: historicalCard?.buttonText,
                            buttonLink: historicalCard?.buttonLink,
                            image: historicalTourCardImage,
                        }}
                    />
                </div>

            {/* Photos Section */}
                {images?.length > 0 && (
                    <CityPhotosSection
                        title={imagesData?.title}
                        subtitle={imagesData?.subtitle}
                        photos={images}
                    />
                )}

            {/* Reviews Section */}
                {reviews?.length > 0 && (
                    <CityReviewsSection
                        logos={reviewsLogos}
                        rating={reviewsData?.averageRating}
                        ratingSubtitle={reviewsData?.subtitle}
                        reviews={reviews}
                    />
                )}
        </div>
    );
}
